<div class="info-drag-table ">
  <div *ngFor="let item of permissions" class="info-drag-table-row">
    <div class="info-drag-table-cell">{{ item?.group | transloco }}</div>
    <div [ngClass]="{ 'may' : item.flag === 0, 'mustNot' : item.flag === 1 }" class="info-drag-table-cell">{{ item.permission }}</div>
  </div>
</div>
